<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-account-cash-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="investorListColumnPlugins"
        v-column-drag="investorListColumnPlugins"
        v-column-pin="investorListColumnPlugins"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y :z-index="100">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item link @click="edit(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-clipboard-edit</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('edit')" />
                </v-list-item>
                <v-list-item link @click="print(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-printer-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('print')" />
                </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat((item.price ? item.price.price : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.head.doc_header.number="{ item }">
          <a
            v-if="item.head.doc_header"
            @click="openComponent('accountingPrint', item.head.doc_head_id)"
          >
            {{ item.head.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.head.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.head.customer_id)"
            >
              {{ item.head.customer.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.head.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.product.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('product', item.product_id)"
            >
              {{ item.product.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('productTurnover', item.product_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('productTurnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.count="{ item }">
          {{ $numberFormat((item.count ? item.count : 0)) }}
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat((item.fee ? item.fee : 0)) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sum="{ item }">
          {{ $numberFormat((item.sum ? item.sum : 0)) }}
        </template>
        <template v-slot:item.cost="{ item }">
          {{ $numberFormat((item.cost ? item.cost : 0)) }}
        </template>
        <template v-slot:item.profit="{ item }">
          {{ $numberFormat((item.profit ? item.profit : 0)) }}
        </template>
        <template v-slot:item.InvestorShare="{ item }">
          {{ $numberFormat((item.profit ? (item.profit * (item.percent / 100)).toFixed(0) : 0)) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.sum_invoice="{ item }">
          {{ (item.sum_invoice ? $numberFormat(item.sum_invoice) : 0) }}
        </template>
        <template v-slot:item.sum_cost_product_in="{ item }">
          {{ (item.sum_cost_product_in ? $numberFormat(item.sum_cost_product_in) : 0) }}
        </template>
        <template v-slot:item.sum_return_cost="{ item }">
          {{ (item.sum_return_cost ? $numberFormat(item.sum_return_cost) : 0) }}
        </template>
        <template v-slot:item.sum_cost_product_out="{ item }">
          {{ (item.sum_cost_product_out ? $numberFormat(item.sum_cost_product_out) : 0) }}
        </template>
        <template v-slot:item.sum_cost="{ item }">
          {{ (item.sum_cost ? $numberFormat(item.sum_cost) : 0) }}
        </template>
        <template v-slot:item.return_sum_invoice="{ item }">
          {{ (item.return_sum_invoice ? $numberFormat(item.return_sum_invoice) : 0) }}
        </template>
        <template v-slot:item.profit="{ item }">
          {{ $numberFormat(+item.sum_invoice - +item.sum_cost - +item.sum_cost_product_out) }}
        </template>
        <template v-slot:item.InvestorShare="{ item }">
          {{ $numberFormat(((+item.sum_invoice - +item.return_sum_invoice + +item.sum_cost_product_in + +item.sum_return_cost - +item.sum_cost - +item.sum_cost_product_out) * (item.percent / 100)).toFixed(0)) }}
        </template>
        <template
          v-slot:body.append
        >
          <tr
            v-if="isMobile || isTablet || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - 7}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:6}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('InvestorShare') +':': '') }}  {{ $numberFormat(totals.investorShare) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ investorListFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("sellFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="investor"
                :title="$t('investor')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="account"
                :title="$t('customer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="product"
                type="product"
                :title="$t('product')"
                :outlined="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <status
                v-model="sellStatus"
                :hideconfig="true"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-numeric</v-icon>
              {{ $t("accFilterNumberAmount") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-text-field
                v-model="fromNumber"
                :label="$t('from') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-text-field
                v-model="toNumber"
                :label="$t('until') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("productEntrepotFilterGroups") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="group"
                :title="$t('main-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'group'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat1"
                :title="$t('other-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'category'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat2"
                title="category"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'subcategory'})"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="entrepot"
                title="entrepot"
                type="entrepot"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="accountCategory"
                :title="$t('accountCategory')"
                type="accountCategory"
                :filter="true"
                :multiple="true"
              />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  // import { ipcRenderer } from 'electron'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'InvestorList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId'],
    data: () => ({
      excelItems: [],
      selected: [],
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      accountCategory: null,
      entrepot: null,
      investor: null,
      cat2: null,
      cat1: null,
      group: null,
      dialogData: null,
      product: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      integratType: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      // Table pagination options. Kept separate from `options` because the
      // General mixin reuses `options` for money formatting (filter Money fields)
      // and overwrites it. This page intentionally uses 5 items per page.
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
      },
      headers: null,
      listViewportObserver: null,
      listViewportRaf: null,
      getInvestor: null,
      type: null,
      search: null,
      pageCount: 1,
      page: 1,
      selectedHeaders: [],
      headersMap: null,
    }),
    computed: {

      investorListFilterTitle () {
        var map = {
          sellInvestor: 'sellInvestorFilterTitle',
          returnSellInvestor: 'returnSellInvestorFilterTitle',
        }
        var key = map[this.$route.name] || 'sellInvestorFilterTitle'
        return this.$t(key)
      },
      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var defs = [
          ['investor', app.$t('investor')],
          ['account', app.$t('customer')],
          ['product', app.$t('product')],
          ['currencyFilter', app.$t('currency')],
          ['fromAmount', app.$t('from') + ' ' + app.$t('amount')],
          ['toAmount', app.$t('until') + ' ' + app.$t('amount')],
          ['fromNumber', app.$t('from') + ' ' + app.$t('number')],
          ['toNumber', app.$t('until') + ' ' + app.$t('number')],
          ['fromDate', app.$t('from') + ' ' + app.$t('date')],
          ['toDate', app.$t('until') + ' ' + app.$t('date')],
          ['tag', app.$t('tag')],
          ['sellStatus', app.$t('status')],
          ['group', app.$t('main-group')],
          ['cat1', app.$t('other-group')],
          ['cat2', app.$t('category')],
          ['branch', app.$t('branch')],
          ['entrepot', app.$t('entrepot')],
          ['accountCategory', app.$t('accountCategory')],
        ]
        return defs
          .filter(function (d) { return has(app[d[0]]) })
          .map(function (d) {
            return { key: d[0], label: d[1], value: show(app[d[0]]) }
          })
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.isTablet && !this.mobileShow
      },
      investorListColumnPersistKey () {
        return 'investor-list-columns-' + (this.$route.name || 'sellInvestor')
      },
      investorListLockedColumns () {
        var locked = ['actions']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      investorListColumnPlugins () {
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.showHeaders || [])
          : this.showHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.investorListLockedColumns,
          anchor: 'actions',
          minWidth: 60,
          persistKey: this.investorListColumnPersistKey,
        }
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type === 'returnSell') {
            if (s.value === 'cost' || s.value === 'profit' || s.value === 'commission' || s.value === 'processing' || s.value === 'shipping') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else if (app.type === 'sell') {
            if (s.value === 'returnCommission' || s.value === 'returnShipping' || s.value === 'returnBackFromCustomer' || s.value === 'penaltyCancelling' || s.value === 'returnProcessing') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        const totals = this.items.reduce((acc, d) => {
          acc.sumInvoice += parseFloat(d.sum_invoice)
          acc.sum_out += parseFloat(d.sum_out)
          acc.sum_in += parseFloat(d.sum_in)
          acc.sum_cost_product_out += parseFloat(d.sum_cost_product_out)
          acc.sum_cost_product_in += parseFloat(d.sum_cost_product_in)
          acc.sum_cost += parseFloat(d.sum_cost)
          acc.investorShare += parseFloat(((+d.sum_invoice - +d.return_sum_invoice + +d.sum_cost_product_in + +d.sum_return_cost - +(app.type === 'sell' ? d.sum_cost_product_out : d.sum_cost_product_in) - +d.sum_cost) * (d.percent / 100)).toFixed(0))
          return acc
        }, {
          sumInvoice: 0,
          sum_out: 0,
          sum_in: 0,
          sum_cost_product_out: 0,
          sum_cost_product_in: 0,
          sum_cost: 0,
          investorShare: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          ;(app.tableOptions.sortBy || []).map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            if (index > -1) {
              app.sortBy.push(app.headers[index].table)
            }
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    activated () {
    // this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    beforeMount () {
      if (this.$route.name === 'sellInvestor') {
        this.type = 'sell'
        this.getInvestor = 'active'
      }
      if (this.$route.name === 'returnSellInvestor') {
        this.type = 'returnSell'
        this.getInvestor = 'active'
      }
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('investor'),
          sortable: false,
          value: 'account.name',
          width: 150,
        },
        {
          text: this.$t('investorPercent'),
          sortable: false,
          value: 'percent',
          width: 80,
        },
        {
          text: this.$t('sumInvoice'),
          sortable: false,
          value: 'sum_invoice',
        },
        {
          text: this.$t('sumReturnInvoice'),
          sortable: false,
          value: 'return_sum_invoice',
        },
        {
          text: this.$t('sumProductCost'),
          sortable: false,
          value: 'sum_cost_product_out',
        },
        {
          text: this.$t('sumReturnProductCost'),
          sortable: false,
          value: 'sum_cost_product_in',
        },
        {
          text: this.$t('sumOtherCost'),
          sortable: false,
          value: 'sum_cost',
        },
        {
          text: this.$t('sumOtherReturnCost'),
          sortable: false,
          value: 'sum_return_cost',
        },
        {
          text: this.$t('profit') + ' (' + this.$store.state.currency.name + ')',
          sortable: false,
          value: 'profit',
        },
        {
          text: this.$t('InvestorShare') + ' (' + this.$store.state.currency.name + ')',
          sortable: false,
          value: 'InvestorShare',
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.investorListLockedColumns,
        anchor: 'actions',
      })
      this.loadInvestorListColumnSettings()
    },
    mounted () {
      // Preserve existing page size for this report (was options.itemsPerPage = 5)
      this.tableOptions.itemsPerPage = 5
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    methods: {

      resetFilters () {
        var app = this
        ;[
          'investor', 'account', 'product', 'currencyFilter',
          'fromAmount', 'toAmount', 'fromNumber', 'toNumber',
          'fromDate', 'toDate', 'tag', 'sellStatus',
          'group', 'cat1', 'cat2', 'branch', 'entrepot', 'accountCategory',
        ].forEach(function (k) { app[k] = null })
      },
      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const colMarginTop = parseFloat(colStyle.marginTop) || 0
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          colMarginTop -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadInvestorListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.investorListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.investorListLockedColumns,
            anchor: 'actions',
          })
          app.$forceUpdate()
        })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: this.type + 'Edit', params: { id: item.head.uid } })
      },
      print (item) {
        this.printId = item.head.uid
        this.invoicePrintDialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        app.filter = false
        app.$axios.get(this.$endpoint + 'invoiceReport', {
          params: {
            select: 'investor',
            getInvestor: app.getInvestor,
            search: app.search,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            accountCategory: app.accountCategory,
            entrepot: app.entrepot,
            branch: app.branch,
            product: app.product,
            investor: app.investor,
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            integratType: app.integratType,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            page: (app.allRows ? app.excelPage : app.tableOptions.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            type: app.type,
            investor: (d.account ? d.account.name : ''),
            percent: d.percent,
            sumInvoice: d.sum_invoice,
            sum_other_cost: d.sum_cost,
            sum_count_out: d.sum_out,
            sum_count_in: d.sum_in,
            sum_cost_product_out: d.sum_cost_product_out,
            sum_cost_product_in: d.sum_cost_product_in,
            investorShare: ((+d.sum_invoice - +d.return_sum_invoice + +d.sum_cost_product_in + +d.sum_return_cost - +(app.type === 'sell' ? d.sum_cost_product_out : d.sum_cost_product_in) - +d.sum_cost) * (d.percent / 100)).toFixed(0),
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";


</style>
